import * as Yup from "yup";
import { editTicketUserRolesService } from "../../services/ticketsServices.js";
import Alert from "../../utils/Alert.js";

export const initialValues = {
    user_role: ""
};


export const onSubmit = async (values, actions, editingTikcet, setTickets, navigate) => {
    const { userRole } = localStorage.getItem("cncToken") ? JSON.parse(localStorage.getItem("cncToken")) : navigate("/auth/login");
    
    try {
        const response = await editTicketUserRolesService(editingTikcet.code, values);
        if(response.status === 200) {
            const { user_role } = response.data;
            if(!user_role.includes(userRole.id)) {
                setTickets(prevTickets => prevTickets.filter(t => t.code !== editingTikcet.code));
            } else {
                setTickets(prevTickets => prevTickets.map(t => {
                    if(t.code === editingTikcet.code) {
                        return {
                            ...t,
                            user_role
                        };
                    }
                    return t;
                }))
            }
            Alert("انجام عملیات", "نقش گیرندگان تیکت با موفقیت ویرایش شد", "success");
            return navigate(-1);
        }
    } catch (error) {
        
    }
}

export const validationSchema = Yup.object({
    user_role: Yup.array().min(1, "باید حداقل یک نقش انتخاب شود")
});